"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepContainer = exports.socialLoginLayoutChooser = exports.SOCIAL_LOGIN_LAYOUTS = void 0;
exports.socialLoginFactory = socialLoginFactory;
const react_1 = __importDefault(require("react"));
const auth_1 = require("../logic/auth");
const theme_1 = require("../utils/theme");
const ToS_1 = require("./ToS");
const TraditionalLogin_1 = require("./TraditionalLogin");
const misc_1 = require("../utils/misc");
const Logo_1 = require("./Logo");
const SocialChooseStep_1 = require("./SocialChooseStep");
const ChooseEmailDomain_1 = require("./ChooseEmailDomain");
const VerificationMessage_1 = require("./VerificationMessage");
const WaitingReview_1 = require("./WaitingReview");
const ChooseRole_1 = require("./ChooseRole");
const Success_1 = require("./Success");
const BuyerToConsumer_1 = require("./BuyerToConsumer");
const config_1 = require("../logic/config");
const css_manager_1 = require("@food/css-manager");
const ErrorMessage_1 = require("@food/ui/build/dist/src/ErrorMessage");
const types_1 = require("../types");
const TemporaryConsumer_1 = require("./TemporaryConsumer");
const tracking_1 = require("@food/tracking");
const oauth_1 = require("../utils/oauth");
const InsertWorkEmail_1 = require("./InsertWorkEmail");
const steps_1 = require("../logic/steps");
const SwitchToSocial_1 = require("./SwitchToSocial");
const ErrorStep_1 = require("./ErrorStep");
const RememberSocialStep_1 = require("./RememberSocialStep");
const VerifyLinkExpired_1 = require("./VerifyLinkExpired");
const track_1 = require("../utils/track");
const server_types_1 = require("../server-types");
const ChooseUpgradeRole_1 = require("./ChooseUpgradeRole");
const Sentry = __importStar(require("@sentry/browser"));
const react_router_1 = require("react-router");
const react_ga_1 = require("react-ga");
const ResetPassword_1 = require("./ResetPassword");
var SOCIAL_LOGIN_LAYOUTS;
(function (SOCIAL_LOGIN_LAYOUTS) {
    SOCIAL_LOGIN_LAYOUTS["STANDARD"] = "STANDARD";
    SOCIAL_LOGIN_LAYOUTS["COMPACT"] = "COMPACT";
})(SOCIAL_LOGIN_LAYOUTS || (exports.SOCIAL_LOGIN_LAYOUTS = SOCIAL_LOGIN_LAYOUTS = {}));
const socialLoginLayoutChooser = (width) => width > 800 ? SOCIAL_LOGIN_LAYOUTS.STANDARD : SOCIAL_LOGIN_LAYOUTS.COMPACT;
exports.socialLoginLayoutChooser = socialLoginLayoutChooser;
// data l'ultima risposta del server, restituisco i dati necessari per la prossima richiesta
// ancora in costruzione
// TODO spostare in un file apposta
/*const pickArgsFromResponse = (response: IServerResponse): any => {
    const base: any = {};
    if (response.cryptoRenewToken) {
        base.cryptoRenewToken = response.cryptoRenewToken;
    }
    return base;
};*/
const isPayloadWithChoices = (response) => {
    return !!response.choices;
};
// data l'ultima risposta, ne prendo i tos
// TODO spostare in un file apposta
const pickToSFromResponse = (response) => response.choices;
// data l'ultima risposta, ne prendo il bearer
// TODO spostare in un file apposta
/*const pickBearerFromResponse = (response: IServerResponse): string =>
    response && response.userAuth && response.userAuth.authorization;*/
// data l'ultima risposta, prende il tipo di social usato per il login / a cui e' accoppiato l'utente
// TODO spostare in un file apposta
const pickSocialTypeFromResponse = (response) => {
    const userSocialtype = response?.userAuth?.userSocialtype;
    return (0, types_1.isSocial)(userSocialtype) ? userSocialtype : undefined;
};
const pickEmailDomainsFromResponse = (response) => response?.choices;
const loadingStep = (0, css_manager_1.registerClass)((theme) => `
width: 100%;
min-height: 20vh;
> div {
	text-align: center;
	padding: ${theme.ratios.l / 2}em;
}`);
const style = (0, css_manager_1.registerClass)((theme) => `
max-width: 900px;
min-width: 500px;
background: ${theme.colors.white};
line-height: ${theme.ratios.l}em;
color: ${theme.colors.ink};
margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;

> h2 {
	font-size: ${theme.ratios.xl}em;
	line-height: ${theme.ratios.xl}em;
	color: ${theme.colors.ink};
	background-color: ${theme.colors.grey.light};
	text-align: center;
	margin-bottom: ${(theme.ratios.l / 2) * theme.font.baseSize}px;
}

> section {
	padding: ${theme.ratios.l * theme.font.baseSize}px;
	padding-top: ${(theme.ratios.l / 2) * theme.font.baseSize}px

	.skip {
		font-size: ${theme.ratios.s}em;
		text-align: center;
	}

	a {
		cursor: pointer;
		color: ${theme.colors.grey.plain};
		text-decoration: underline;
	}
	
	> p, > div > p {
		margin-top: ${theme.font.baseSize}px;
		
		&:first-child {
			margin-top: 0;
		}
	}
}`);
const StepContainer = ({ children }) => (react_1.default.createElement("div", { className: style }, children));
exports.StepContainer = StepContainer;
function socialLoginFactory(t) {
    return (0, react_router_1.withRouter)(class SocialLogin extends react_1.default.Component {
        constructor(props) {
            super(props);
            this.goToResetPasswordView = () => {
                this.setState({ resetPassword: true });
            };
            this.renderError = (step) => {
                const { errors } = this.state;
                const { tokens } = this.props;
                if (errors && errors.length) {
                    return (react_1.default.createElement("div", null, errors.map((e) => {
                        let { key, type } = e;
                        /*if (
                            key === 'grantToken.email' &&
                            socialType === 'FACEBOOK'
                        ) {
                            key = 'grantToken.email facebook';
                        }*/
                        const errorId = key
                            ? `${key} ${type} error`
                            : 'generic error';
                        // ci sono alcuni casi in cui gli errori non devono venire mostrati in quanto parte di un normale
                        // svolgimento della procedura di login. Ad esempio, quando sto associando un sfContactId a un
                        // utente con bearer scaduto ricevo un errore, ma non si tratta di un malfunzionamento.
                        // Qui controllo questi casi e, se si verificano, non restituisco errore.
                        if ((step === steps_1.AuthSteps.CREDENTIAL_INPUT_TRADITIONAL ||
                            step === steps_1.AuthSteps.CREDENTIAL_INPUT_SOCIAL) &&
                            key === 'options.authToken' &&
                            type === 'INVALID_VALUE' &&
                            tokens.sfContactId) {
                            return react_1.default.createElement("span", null);
                        }
                        // di default restistuisco semplicemente un messaggio di errore per ogni errore
                        return (react_1.default.createElement(ErrorMessage_1.ErrorMessage, { key: (key || +new Date()) + ' error', error: t(errorId) }));
                    })));
                }
                return null;
            };
            this.deriveFromState = (newState) => {
                const s = newState || this.state;
                const { config } = this.state;
                // Filter out 'TRADITIONAL' socialType for API calls as server doesn't recognize it
                const socialType = s.socialType && (0, types_1.isSocial)(s.socialType)
                    ? s.socialType
                    : undefined;
                return {
                    sourceApp: config.TARGET_SITE,
                    role: s.role,
                    cryptoRenewToken: s.serverAuth?.payload?.cryptoRenewToken,
                    workEmail: s.email,
                    userSocialLinkToken: s.userSocialLinkToken,
                    tosApproved: s.tosAccepted,
                    newsletterAccepted: s.newsletterAccepted,
                    EmailDomain_id: s.emailDomain,
                    // Only include socialType if it's a valid SOCIAL (not 'TRADITIONAL')
                    socialType: socialType,
                    grantToken: s.grantToken,
                };
            };
            this.historySetState = (state) => {
                this.setState({
                    ...state,
                    history: this.state.history.concat([{ ...this.state }]),
                });
            };
            /**
             * Funzione per controllare, al caricamento del componente, il token nell'url con il server
             * Puo' portare al SUCCESS, alla scelta del dominio, o a un messaggio di declassamento da BUYER a CONSUMER
             */
            this.performVerify = async () => {
                const { authManager, tokens, redirectOnLogin } = this.props;
                const authFromState = this.deriveFromState();
                if (authFromState.cryptoRenewToken) {
                    // se sei già loggato, non devo fare il controllo
                    return;
                }
                const serverAuth = await authManager.authenticate(authFromState, tokens, true, redirectOnLogin);
                if (!serverAuth.success ||
                    serverAuth.payload.EmailDomainRow ||
                    serverAuth.payload.userStatus === 'WAITING_REVIEW') {
                    this.parseServerResponse(serverAuth);
                }
                else {
                    this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype);
                }
            };
            this.tryTraditionalLogin = async ({ email, password, }) => {
                const { authManager, tokens } = this.props;
                this.setState({ loading: true });
                const loginResult = await authManager.authenticate({
                    ...this.deriveFromState(this.state),
                    email,
                    password,
                }, tokens, false);
                if (loginResult.success) {
                    // sono riuscito a loggarmi tramite username/password, ma forse non ho alcun account social associato
                    // se non ne ho neanche uno associato allora mostro la schermata per associare.
                    // chiaramente questo procedimento esclude gli internal
                    if (loginResult.payload.userAuth?.auth.user.role ===
                        server_types_1.UserRole.Internal) {
                        await this.successfulLoginHandler(loginResult, 'TRADITIONAL');
                        return;
                    }
                    else {
                        // segnalo ad analytics che ho avuto un login da social
                        (0, react_ga_1.event)({
                            category: 'User',
                            action: 'Sign in',
                            label: 'credentials',
                        });
                        this.setState({
                            loading: false,
                            serverAuth: loginResult,
                        });
                    }
                }
                else {
                    // ho ricevuto un errore, parso la risposta e la gestisco
                    this.parseServerResponse(loginResult, {
                        errors: [loginResult.payload],
                    });
                }
            };
            this.trySocialUpgrade = async (social) => {
                const { authManager, tokens } = this.props;
                const socialType = authManager.SOCIAL_TYPES[social];
                // Update state to store the social type for upgrade
                this.setState({
                    socialType: socialType.key,
                    loading: true,
                });
                try {
                    const grantToken = await (0, oauth_1.oAuthLogin)({
                        socialType,
                    });
                    // check if already registered
                    if (grantToken) {
                        const changedState = {
                            socialType: socialType.key,
                            grantToken,
                            loading: false,
                        };
                        const serverAuth = await authManager.authenticate({
                            ...this.deriveFromState({
                                ...this.state,
                                ...changedState,
                            }),
                            grantToken,
                            socialType: socialType.key,
                        }, tokens, true);
                        if (serverAuth.payload.userAuth &&
                            serverAuth.payload.userAuth.success === true &&
                            serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                            this.successfulLoginHandler(serverAuth, social);
                        }
                        else {
                            this.parseServerResponse(serverAuth, changedState);
                        }
                    }
                    else {
                        // Handle case where no grantToken is returned
                        this.setState({
                            loading: false,
                            errors: [
                                { key: 'social_upgrade', type: 'NO_GRANT_TOKEN' },
                            ],
                        });
                    }
                }
                catch (e) {
                    console.error(e);
                    console.warn('Access to social data denied, nothing to do!');
                    this.setState({
                        loading: false,
                        errors: [{ key: 'social_upgrade', type: 'ACCESS_DENIED' }],
                    });
                }
            };
            this.trySocialLogin = async ({ fixedSocial, }) => {
                const { authManager, tokens } = this.props;
                const socialType = authManager.SOCIAL_TYPES[fixedSocial];
                // console.log('Social type', socialType);
                // console.log('fixedSocial', fixedSocial);
                // Update state immediately to store the social type
                this.setState({
                    socialType: socialType.key,
                    loading: true,
                });
                try {
                    const grantToken = await (0, oauth_1.oAuthLogin)({
                        socialType,
                    });
                    // check if already registered
                    if (grantToken) {
                        const changedState = {
                            socialType: socialType.key,
                            grantToken,
                            loading: false,
                        };
                        const newState = {
                            ...this.state,
                            ...changedState,
                            authToken: null,
                        };
                        const serverAuth = await authManager.authenticate({
                            ...this.deriveFromState(newState),
                            grantToken,
                            socialType: socialType.key,
                        }, tokens, false);
                        if (serverAuth.payload.userAuth &&
                            serverAuth.payload.userAuth.success === true) {
                            // segnalo ad analytics che ho avuto un login da social
                            // nota: se l'utente e' in WAITING REVIEW ma si e' autenticato devo comunque avvisare analytics di avvenuto login
                            (0, react_ga_1.event)({
                                category: 'User',
                                action: 'Sign in',
                                label: 'social',
                            });
                        }
                        if (serverAuth.payload.userAuth &&
                            serverAuth.payload.userAuth.success === true &&
                            serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                            // save and complete
                            this.successfulLoginHandler(serverAuth, socialType.key);
                        }
                        else {
                            // not registered or waiting review, continue with registration
                            this.parseServerResponse(serverAuth, changedState);
                        }
                    }
                    else {
                        // Handle case where no grantToken is returned
                        this.setState({
                            loading: false,
                            errors: [{ key: 'social_login', type: 'NO_GRANT_TOKEN' }],
                        });
                    }
                }
                catch (e) {
                    console.error(e);
                    console.warn('Access to social data denied, nothing to do!');
                    this.setState({
                        loading: false,
                        errors: [{ key: 'social_login', type: 'ACCESS_DENIED' }],
                    });
                }
            };
            // save registration
            this.performRegister = async (newState) => {
                const { authManager, tokens, redirectOnLogin } = this.props;
                // attempt to save registration
                const serverAuth = await authManager.authenticate(this.deriveFromState(newState), tokens, false, redirectOnLogin);
                if (serverAuth.success) {
                    // segnalo ad analytics che ho avuto un nuovo utente registrato
                    (0, react_ga_1.event)({
                        category: 'User',
                        action: 'Registration',
                        label: serverAuth.payload.userStatus,
                    });
                }
                // check if already registered,
                if (serverAuth.success &&
                    serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                    /*if (serverAuth.payload.EmailDomainRow) {
                    // sono in fase di registrazione, mando alla schermata di successo
                    this.setState({
                        // phase: 'SUCCESS',
                        loading: false,
                        errors: null,
                        serverAuth,
                    });
                } else if () {
                    this.setState({
                        // phase: 'WAITING_REVIEW',
                        loading: false,
                        errors: null,
                        serverAuth,
                    });
                } else {*/
                    this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype || 'TRADITIONAL');
                    // }
                }
                else {
                    this.parseServerResponse(serverAuth, newState);
                }
            };
            this.acceptTos = ({ id: tosLocalId, newsletter, }) => {
                const stateUpdate = {
                    tosAccepted: tosLocalId,
                    newsletterAccepted: newsletter,
                };
                const newState = {
                    ...this.state,
                    ...stateUpdate,
                };
                this.performRegister(newState);
                this.setState(newState);
            };
            this.roleChooser = (role) => {
                const newState = {
                    role,
                };
                this.setState({
                    ...newState,
                    loading: true,
                });
                this.performRegister({
                    ...this.state,
                    ...newState,
                });
            };
            // TODO estrarne almeno una parte
            this.upgradeRole = async (role) => {
                const { tokens, authManager } = this.props;
                const stateChanges = {
                    role,
                    loading: true,
                };
                this.setState(stateChanges);
                const newState = {
                    ...this.state,
                    ...stateChanges,
                };
                const serverAuth = await authManager.authenticate(this.deriveFromState(newState), tokens, true);
                if (serverAuth.success &&
                    serverAuth.payload.userStatus !== 'WAITING_REVIEW') {
                    this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype || 'TRADITIONAL');
                    // }
                }
                else {
                    this.parseServerResponse(serverAuth, newState);
                }
            };
            this.back = () => {
                const { history } = this.state;
                const oldState = history.pop();
                if (oldState) {
                    this.setState({
                        ...oldState,
                        email: undefined,
                        errors: undefined,
                        loading: false,
                        forcedChangeWorkEmail: false,
                        serverAuth: oldState.serverAuth || undefined,
                    });
                }
                else {
                    // back without previus state
                    Sentry.withScope((scope) => {
                        scope.setExtra('oldState', oldState);
                        Sentry.captureException(new Error('back without previus state'));
                    });
                }
            };
            //
            this.clearTokens = () => {
                const { location, history } = this
                    .props;
                const { search, pathname } = location;
                if (search) {
                    history.replace(pathname);
                }
            };
            // funzione per chiudere la modale, qualora si trattasse di modale
            // in effetti non fa altro che pulire l'url e chiamare un eventuale listener
            this.close = () => {
                // TODO il close, se chiamato su step post autenticazione, dovrebbe lanciare il success handler
                // TODO il close dovrebbe essere chiamato con un parametro per distinguere i caso in cui il login e' andato a buon fine
                const { onClose } = this.props;
                this.clearTokens();
                if (onClose) {
                    onClose();
                }
            };
            this.parseServerResponse = (serverAuth, changedState = {}) => {
                const { config } = this.state;
                // Preserve socialType from current state if not provided in changedState
                const preservedSocialType = changedState.socialType || this.state.socialType;
                // qualsiasi sia lo stato emergente da questa elaborazione, avra' queste caratteristiche
                const newState = {
                    ...changedState,
                    serverAuth,
                    loading: false,
                    socialType: preservedSocialType, // Ensure socialType is preserved
                };
                /**
                 * Ci sono casi in cui non imposto serverAuth e quindi mi perderei
                 * serverAuth.payload.cryptoRenewToken con conseguente errore sulla
                 * chiamata successiva perché manca un qualsiasi metodo di autenticazione.
                 */
                if (serverAuth.payload.cryptoRenewToken) {
                    this.setState({
                        serverAuth,
                        socialType: preservedSocialType, // Preserve socialType here too
                    });
                }
                if (serverAuth.payload.key) {
                    if (serverAuth.payload.key.includes('options.tosApproved')) {
                        // potrebbe avermi passato anche un cryptoRenewToken
                        this.historySetState(newState);
                    }
                    else if (serverAuth.payload.key.includes('options.role')) {
                        // sono nel caso in cui chiedo il ruolo dell'utente da registrare
                        if (config.AUTH_ROLES.length === 1 &&
                            config.AUTH_ROLES[0] === server_types_1.UserRole.Consumer) {
                            // se solo il ruolo CONSUMER e' abilitato alla registrazione lo seleziono automaticamente
                            this.roleChooser(server_types_1.UserRole.Consumer);
                            return false;
                        }
                        else {
                            // altrimenti mostro una scelta di pulsanti per scegliere i diversi ruoli
                            // mi serve che sia una `historySetState` perche' devo poter tornare indietro
                            this.historySetState(newState);
                            return false;
                        }
                    }
                    else if (serverAuth.payload.key.includes('options.userSocialLinkToken') &&
                        (0, types_1.isSocial)(this.state.socialType)) {
                        // userSocialLinkToken non valido, rifai la chiamata senza valorizzare userSocialLinkToken
                        this.trySocialLogin({ fixedSocial: this.state.socialType });
                    }
                    else if (serverAuth.payload.key.includes('options.workEmailRoleToken') &&
                        (0, types_1.isSocial)(this.state.socialType)) {
                        // workEmailRoleToken non valido, rifai la chiamata senza valorizzare workEmailRoleToken
                        this.setState({
                            ...newState,
                            workEmailRoleToken: null,
                        });
                        this.trySocialLogin({ fixedSocial: this.state.socialType });
                    }
                    else if ((serverAuth.payload.key === 'options.email' &&
                        serverAuth.payload.type === 'INVALID_VALUE') ||
                        (serverAuth.payload.key === 'options.workEmail' &&
                            serverAuth.payload.type === 'MUST_BE_UNIQUE') ||
                        (serverAuth.payload.key === 'options.workEmail' &&
                            serverAuth.payload.type === 'INVALID_VALUE')) {
                        // sono nel caso di login errato, tentativo di registrazione con email gia' usata o con dominio CONSUMER_ONLY
                        this.setState({
                            loading: false,
                            errors: [serverAuth.payload],
                        });
                        return false;
                    }
                    else {
                        this.historySetState({
                            ...newState,
                            loading: false,
                            errors: [serverAuth.payload],
                        });
                        return false;
                    }
                }
                else if (serverAuth.payload.status === 201 ||
                    serverAuth.payload.userStatus === 'NOT_VERIFIED') {
                    // siamo nel caso in cui e' stata inserita una workEmail. Tendenzialmente mostriamo un messaggio di
                    // conferma che invita a convalidare la mail
                    this.historySetState({
                        ...newState,
                        workEmail: serverAuth.payload.workEmail,
                    });
                    // }
                }
                else {
                    // bho??
                    // caso timeout? errore generico?
                    this.historySetState(newState);
                    return true;
                }
                return true;
            };
            this.orLogout = () => {
                (0, auth_1.logout)();
                this.close();
            };
            this.successfulLoginHandler = (serverResponse /*: IServerResponse*/, loginType) => {
                const { onSuccess } = this.props;
                (0, tracking_1.track)({
                    ...track_1.authTrackOverride,
                    action: {
                        type: 'successful_login',
                        authData: (0, misc_1.cleanUserData)(serverResponse.payload.userAuth),
                    },
                });
                const userAuth = serverResponse.payload.userAuth;
                if (!userAuth?.authorization) {
                    Sentry.withScope((scope) => {
                        scope.setExtra('userAuth', userAuth);
                        Sentry.captureException(new Error('successfulLoginHandler but userAuth without authorization'));
                    });
                }
                else {
                    // l'handler del success deve sempre eseguire DOPO aver impostato a livello globale i dati di autenticazione!!
                    (0, auth_1.setAuth)(userAuth, loginType);
                    this.clearTokens();
                    if (onSuccess !== undefined) {
                        onSuccess();
                    }
                }
            };
            const { config, fixedSocial, startTraditional, instantUpgradeRole, tokens, } = props;
            const mergedConfig = (0, config_1.mergeConfig)(config);
            const { workEmailVerifyToken, sfContactId } = tokens;
            if (workEmailVerifyToken) {
                // sono in una pagina che deve verificare una email di lavoro, appena mi avvio faccio una chiamata
                // probabilmente e' un brutto modo di eseguire un cambio stato applicazione
                this.state = {
                    loading: true,
                    history: [],
                    socialInput: !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                    config: mergedConfig,
                    forcedChangeWorkEmail: false,
                };
                this.performVerify();
            }
            else if (sfContactId && (0, auth_1.isLogged)()) {
                // sono in una pagina che deve collegare ad un account un account salesforce tramite il token passato in
                // url. Nel caso l'utente sia loggato provo a fare la chiamata e mostro qualcosa solo in caso di errore.
                this.state = {
                    loading: true,
                    history: [],
                    socialInput: !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                    config: mergedConfig,
                    forcedChangeWorkEmail: false,
                };
                this.performVerify();
            }
            else if (instantUpgradeRole && (0, auth_1.isLogged)()) {
                // sono in una pagina che deve verificare una email di lavoro, appena mi avvio faccio una chiamata
                // probabilmente e' un bruttor modo di eseguire un cambio stato applicazione
                this.state = {
                    loading: true,
                    history: [],
                    socialInput: !mergedConfig.LOGIN_START_TRADITIONAL && !startTraditional,
                    config: mergedConfig,
                    forcedChangeWorkEmail: false,
                };
                this.upgradeRole(instantUpgradeRole);
            }
            else {
                this.state = SocialLogin._initState(props);
                if (fixedSocial) {
                    // ho cliccato su un qualche pulsante con richiesta di login social, vado a fare direttamente la
                    // richiesta per il login social
                    this.trySocialLogin({ fixedSocial });
                }
            }
        }
        static _initState(props) {
            const { config, tokens: { workEmailRoleToken, userSocialLinkToken }, __initialResponse, startTraditional, forcedRenewAuthType, } = props;
            const mergedConfig = (0, config_1.mergeConfig)(config);
            // controllo se si tratta di un rinnovo o di un login da 0
            const common = {
                workEmailRoleToken,
                userSocialLinkToken,
                history: [],
                loading: false,
                socialInput: startTraditional !== undefined
                    ? !startTraditional
                    : !mergedConfig.LOGIN_START_TRADITIONAL,
                config: mergedConfig,
                forcedChangeWorkEmail: false,
            };
            if ((0, misc_1.isRenew)()) {
                // se sto rinnovando un'autenticazione devo sapere quale forma di login (tradizionale o social) sto rinnovando
                const loginType = (0, auth_1.getLoginType)();
                common.socialType = loginType;
                // Added by the external company, probably useful, I'll leave this here
                // If we have a forced renew auth type, use it to determine the socialType
                if (forcedRenewAuthType &&
                    forcedRenewAuthType !== 'TRADITIONAL' &&
                    (0, types_1.isSocial)(forcedRenewAuthType)) {
                    common.socialType = forcedRenewAuthType;
                }
            }
            if (__initialResponse) {
                // ho una risposta fissata nelle props, sono in un qualche tipo di test, lo inietto nello stato
                common.serverAuth = {
                    success: true,
                    payload: __initialResponse,
                };
            }
            return common;
        }
        render() {
            const { loading, serverAuth, emailDomain, config, errors, socialInput, forcedChangeWorkEmail, } = this.state;
            const { authManager, logo, isModal, layout = SOCIAL_LOGIN_LAYOUTS.STANDARD, customComponent: C, upgradeRole, forcedRenewAuthType, tokens, } = this.props;
            // la view del social login viene dedotta a partire dalla risposta del server e alcuni dati aggiuntivi
            const consumerCanRegister = config.AUTH_ROLES.includes(server_types_1.UserRole.Consumer);
            const isUpgradingRole = (typeof upgradeRole === 'boolean' && upgradeRole) ||
                (Array.isArray(upgradeRole) && upgradeRole.length > 0);
            const phase = (0, steps_1.responseToPhase)(serverAuth && serverAuth.payload, forcedRenewAuthType
                ? forcedRenewAuthType !== 'TRADITIONAL'
                : socialInput, loading, isUpgradingRole, (0, auth_1.getUserData)(), consumerCanRegister, forcedChangeWorkEmail, tokens.sfContactId, this.state.resetPassword);
            if (phase !== this.initialPhase) {
                const action = { type: 'auth_step_changed', new: phase };
                if (this.initialPhase) {
                    action.old = this.initialPhase;
                }
                (0, tracking_1.track)({
                    ...track_1.authTrackOverride,
                    action,
                });
            }
            this.initialPhase = phase;
            // TODO ripristinare il sistema di "indietro"
            const socialTypes = config.SOCIAL_TYPES;
            const leftColElem = C ? (react_1.default.createElement(C, { layout: layout })) : (react_1.default.createElement(Logo_1.Logo, { custom: logo, layout: layout }));
            const user = (0, misc_1.hasUserAuthData)(serverAuth);
            const managed = (0, misc_1.hasEmailDomainData)(serverAuth);
            if (loading) {
                return (react_1.default.createElement("div", { className: (0, css_manager_1.classNames)(style, loadingStep, 'social-login') },
                    react_1.default.createElement("h2", null, t `Sign In / Register`),
                    react_1.default.createElement("div", null,
                        t `loading`,
                        "...")));
            }
            if (serverAuth &&
                phase === steps_1.AuthSteps.MAIL_CONFIRMED_WAITING_REVIEW) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(WaitingReview_1.WaitingReview, { t: t, onClose: () => consumerCanRegister
                            ? this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype)
                            : this.orLogout(), isModal: isModal, supportEmail: config.HELP_EMAIL })));
            }
            else if (phase === steps_1.AuthSteps.CREDENTIAL_INPUT_SOCIAL) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(SocialChooseStep_1.SocialChooseStep, { t: t, socialTypes: socialTypes, logoElem: leftColElem, orLogout: this.orLogout, performLogin: this.trySocialLogin, changePhase: () => this.setState({ socialInput: false }), layout: layout, authManager: authManager, errors: this.renderError(steps_1.AuthSteps.CREDENTIAL_INPUT_SOCIAL), isRenew: (0, misc_1.isRenew)() })));
            }
            else if (phase === steps_1.AuthSteps.CREDENTIAL_INPUT_TRADITIONAL) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(TraditionalLogin_1.TraditionalLogin, { t: t, socialTypes: socialTypes, logoElem: leftColElem, orLogout: this.orLogout, changePhase: () => this.setState({ socialInput: true }), onLogin: this.tryTraditionalLogin, layout: layout, isRenew: (0, misc_1.isRenew)(), errors: this.renderError(steps_1.AuthSteps.CREDENTIAL_INPUT_TRADITIONAL), loading: loading, fixedEmail: (0, auth_1.getUserData)() && (0, auth_1.getUserData)().email, onPasswordResetLink: this.goToResetPasswordView })));
            }
            else if (phase === steps_1.AuthSteps.TERMS_OF_SERVICE) {
                const payload = this.state.serverAuth?.payload;
                const tos = payload && isPayloadWithChoices(payload)
                    ? pickToSFromResponse(payload)[0]
                    : null;
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(ToS_1.ToS, { tos: tos, onBack: this.back, onAgree: (args) => this.acceptTos(args), t: t, lang: config.LANG })));
            }
            else if (phase === steps_1.AuthSteps.CHOOSE_ROLE) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(ChooseRole_1.ChooseRole, { t: t, back: this.back, roleChooser: this.roleChooser, authManager: authManager, roles: config.AUTH_ROLES })));
            }
            else if (serverAuth && phase === steps_1.AuthSteps.ASK_WORK_EMAIL) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(InsertWorkEmail_1.InsertWorkEmail, { t: t, errors: errors, back: this.back, supportEmail: config.HELP_EMAIL, presetWorkEmail: (0, misc_1.extractWorkEmail)(serverAuth), performRegister: (email) => {
                            this.performRegister({
                                ...this.state,
                                email: email.trim().toLowerCase(),
                                forcedChangeWorkEmail: false,
                            });
                        } })));
            }
            else if (serverAuth &&
                phase === steps_1.AuthSteps.CONFIRMATION_EMAIL_SENT) {
                const workEmail = (0, misc_1.extractWorkEmail)(serverAuth);
                if (!workEmail) {
                    Sentry.withScope((scope) => {
                        scope.setExtra('serverAuth', serverAuth);
                        Sentry.captureException(new Error('AuthSteps.CONFIRMATION_EMAIL_SENT but no workEmail'));
                    });
                }
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(VerificationMessage_1.VerificationMessage, { t: t, footer: theme_1.footer, close: this.close, workEmail: workEmail || t `Unknown email`, isModal: isModal, returnToAskEmail: () => this.setState({
                            forcedChangeWorkEmail: true,
                            workEmail: workEmail,
                        }), logout: this.orLogout })));
            }
            else if (serverAuth &&
                phase === steps_1.AuthSteps.CONFIRMATION_EMAIL_SENT_TEMPORARY_CONSUMER) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(TemporaryConsumer_1.TemporaryConsumer, { t: t, proceed: () => this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype), isModal: isModal, user: user, workEmail: (0, misc_1.extractWorkEmail)(serverAuth), supportEmail: config.HELP_EMAIL, returnToAskEmail: () => this.historySetState({
                            ...this.state,
                            forcedChangeWorkEmail: true,
                            workEmail: (0, misc_1.extractWorkEmail)(serverAuth),
                        }) })));
            }
            else if (phase === steps_1.AuthSteps.VERIFY_LINK_EXPIRED) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(VerifyLinkExpired_1.VerifyLinkExpired, { proceed: this.orLogout, t: t, isModal: isModal, supportEmail: config.HELP_EMAIL })));
            }
            else if (serverAuth &&
                phase === steps_1.AuthSteps.SUCCESSFUL_REGISTRATION) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(Success_1.Success, { t: t, proceed: () => this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype), isModal: isModal, user: user, managed: managed, supportEmail: config.HELP_EMAIL })));
            }
            else if (serverAuth &&
                phase === steps_1.AuthSteps.DOWNGRADED_TO_CONSUMER) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(BuyerToConsumer_1.BuyerToConsumer, { t: t, supportEmail: config.HELP_EMAIL, user: user, proceed: () => this.successfulLoginHandler(serverAuth, serverAuth.payload.userSocialtype), isModal: isModal })));
            }
            else if (phase === steps_1.AuthSteps.CHOOSE_EMAIL_DOMAIN) {
                const payload = this.state.serverAuth?.payload;
                const domains = payload && isPayloadWithChoices(payload)
                    ? pickEmailDomainsFromResponse(payload)
                    : [];
                // TODO - Assert domains.length >= 1
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(ChooseEmailDomain_1.ChooseEmailDomain, { t: t, emailDomain: emailDomain, emailDomains: domains, onChoose: () => this.performRegister(this.state), emailDomainChooser: (i) => this.setState({
                            emailDomain: i.id,
                        }), supportEmail: config.HELP_EMAIL })));
            }
            else if (phase === steps_1.AuthSteps.UPGRADE_ROLE) {
                // potrei avere dei ruoli designati per l'upgrade passati direttamente nella chiamata imperativa di
                // `openRenewModal; nel caso non fosse cosi' devo prendere quelli con cui e' stato configurato l'authManager
                const allowedRoles = config.AUTH_ROLES.filter((role) => role !== server_types_1.UserRole.Consumer &&
                    role !== server_types_1.UserRole.Anonymus &&
                    role !== server_types_1.UserRole.Internal);
                const availableRoles = !Array.isArray(upgradeRole)
                    ? allowedRoles
                    : // @ts-ignore
                        upgradeRole.filter((role) => allowedRoles.includes(role));
                if (Array.isArray(upgradeRole) &&
                    //  @ts-ignore
                    upgradeRole.some((role) => allowedRoles.indexOf(role) === -1)) {
                    // check controllo: non dovrebbero esserci ruoli presenti nel richiamo dell'upgrade ma non nella
                    // configurazione generale di auth
                    Sentry.withScope((scope) => {
                        scope.setExtra('Ruoli impostati da config', allowedRoles);
                        scope.setExtra('Ruoli richiesti da chiamata', upgradeRole);
                        Sentry.captureException(new Error('Configurazione errata Auth'));
                    });
                }
                // per l'upgrade adottiamo un approccio generico, non richiedendo all'utente di scegliere il ruolo ma
                // offrendo un generico "professionista". Questo UserRole corrispondera' al primo ruolo a caso fra quelli
                // possibili; stara' poi a noi smistare correttamente l'utente tramite EmailDomain
                let choosenRole = availableRoles[0];
                if (!choosenRole) {
                    // sono finito in un caso strano, segnalo il problema ma provo ad offrire una soluzione
                    Sentry.captureException(new Error("Nessun ruolo richiesto per l'upgrade risulta permesso"));
                    choosenRole = allowedRoles[0];
                    if (!choosenRole) {
                        // caso ancora piu' strano: non ho proprio ruoli accessibili. Segnalo l'errore e restituisco
                        // una schermata di errore tecnico
                        Sentry.captureException(new Error('Chiamato upgrade, ma nessun ruolo permesso'));
                        return (react_1.default.createElement(exports.StepContainer, null,
                            react_1.default.createElement(ErrorStep_1.ErrorStep, { error: t `cannot upgrade error`, t: t, isModal: isModal, supportEmail: config.HELP_EMAIL, close: this.close })));
                    }
                }
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(ChooseUpgradeRole_1.ChooseUpgradeRole, { t: t, upgrade: () => this.upgradeRole(choosenRole), close: this.close })));
            }
            else if (serverAuth && phase === steps_1.AuthSteps.SWITCH_TO_SOCIAL) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(SwitchToSocial_1.SwitchToSocialStep, { t: t, authManager: authManager, socialTypes: socialTypes, performLogin: this.trySocialUpgrade, maybeLaterHandler: () => this.successfulLoginHandler(serverAuth, 'TRADITIONAL'), layout: layout })));
            }
            else if (serverAuth &&
                phase === steps_1.AuthSteps.REMIND_SOCIAL_ACCOUNT) {
                const socialType = pickSocialTypeFromResponse(serverAuth.payload);
                if (!socialType) {
                    // check controllo: non dovrebbero esserci ruoli presenti nel richiamo dell'upgrade ma non nella
                    // configurazione generale di auth
                    Sentry.withScope((scope) => {
                        scope.setExtra('serverAuth.payload', serverAuth.payload);
                        Sentry.captureException(new Error('AuthSteps.REMIND_SOCIAL_ACCOUNT without socialtype'));
                    });
                    this.successfulLoginHandler(serverAuth, 'TRADITIONAL');
                    return (react_1.default.createElement(exports.StepContainer, null,
                        react_1.default.createElement(ErrorStep_1.ErrorStep, { error: t `AuthSteps.REMIND_SOCIAL_ACCOUNT without socialtype`, t: t, isModal: isModal, supportEmail: config.HELP_EMAIL, close: this.close })));
                }
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(RememberSocialStep_1.RememberSocialStep, { t: t, proceed: () => this.successfulLoginHandler(serverAuth, 'TRADITIONAL'), socialType: socialType })));
            }
            else if (phase === steps_1.AuthSteps.RESET_PASSWORD_EMAIL_PROMPT) {
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(ResetPassword_1.ResetPassword, { t: t, logoElem: leftColElem, changePhase: () => this.setState({ socialInput: true }), layout: layout, loading: loading, config: this.state.config, onGoBack: () => this.setState({ resetPassword: false }) })));
            }
            else {
                // viste le condizioni precedenti, questo implica `phase instanceOf Error === true`
                return (react_1.default.createElement(exports.StepContainer, null,
                    react_1.default.createElement(ErrorStep_1.ErrorStep, { error: this.renderError(), t: t, isModal: isModal, supportEmail: config.HELP_EMAIL, close: () => (isModal ? this.close() : this.orLogout()) })));
            }
        }
    });
}
//# sourceMappingURL=SocialLogin.js.map